<template>
  <modal-2 ref="ticket_modal" sheet-class="ct-sheet" :hideFooter="true">
    <template #header>
      <h4 class="tk-title">
        <span class="tk-title-ic"><i class="fas fa-ticket-alt"></i></span>
        <span>{{ ui.csm_ticket_no || ui.erp_ticket_no || 'Ticket No.' }}</span>
        <span class="tk-docno">{{ docno }}</span>
      </h4>
    </template>
    <template #body>
      <div class="tk-loading" v-if="loading">
        <i class="fas fa-spinner fa-spin"></i> {{ ui.erp_loading || 'Loading...' }}
      </div>
      <div class="callout callout-warning" v-else-if="!ticket">
        {{ ui.csm_trn_ticket_not_found || 'ไม่พบข้อมูลของ Ticket นี้' }}
      </div>
      <template v-else>
        <div class="tk-head">
          <span class="tk-subject">{{ ticket.subject || '-' }}</span>
          <span class="tk-date" v-if="ticket.doc_date"><i class="far fa-clock"></i> {{ ticket.doc_date }}</span>
        </div>

        <div class="tk-grid">
          <div class="tk-item" v-for="(f, idx) in fields" :key="idx" :class="'tone-' + f.tone">
            <span class="tk-item-ic"><i class="fas" :class="f.icon"></i></span>
            <span class="tk-item-body">
              <span class="tk-label">{{ f.label }}</span>
              <span class="tk-value">{{ f.value }}</span>
            </span>
          </div>
        </div>

        <div class="tk-block tone-indigo" v-if="!xt.isEmpty(ticket.description)">
          <div class="tk-block-head">
            <span class="tk-head-ic"><i class="fas fa-align-left"></i></span>
            {{ ui.csm_v2_description || 'รายละเอียด' }}
          </div>
          <div class="tk-desc">{{ ticket.description }}</div>
        </div>

        <div class="tk-block tone-cyan" v-if="!xt.isEmpty(ticket.website_url)">
          <div class="tk-block-head">
            <span class="tk-head-ic"><i class="fas fa-link"></i></span>
            Website URL
          </div>
          <a :href="ticket.website_url" target="_blank" class="tk-url">{{ ticket.website_url }}</a>
        </div>

        <div class="tk-block tone-rose" v-if="!xt.isEmpty(ticket.map_url) || !xt.isEmpty(ticket.map_gps)">
          <div class="tk-block-head">
            <span class="tk-head-ic"><i class="fas fa-map-marker-alt"></i></span>
            {{ ui.csm_trn_workplace || 'สถานที่ปฏิบัติงาน' }}
          </div>
          <a v-if="!xt.isEmpty(ticket.map_url)" :href="ticket.map_url" target="_blank" class="tk-url">{{ ticket.map_url }}</a>
          <div class="tk-desc" v-if="!xt.isEmpty(ticket.map_gps)">{{ ticket.map_gps }}</div>
          <div class="tk-desc" v-if="!xt.isEmpty(ticket.map_desc)">{{ ticket.map_desc }}</div>
        </div>

        <div class="tk-block tone-teal" v-if="comments.length > 0">
          <div class="tk-block-head">
            <span class="tk-head-ic"><i class="fas fa-comments"></i></span>
            {{ ui.csm_trn_external_comment || 'การตอบกลับ' }}
            <span class="tk-count">{{ comments.length }}</span>
          </div>
          <div class="tk-chat">
            <div class="tk-msg" v-for="(c, idx) in comments" :key="idx" :class="{ 'is-me': c.is_me }">
              <span class="tk-msg-avatar" :class="'av-' + avatarTone(c.user)">
                <img v-if="c.img" :src="showPicture(c.img)" @error="$event.target.style.display='none'" />
                <span v-else>{{ (c.user || '-').charAt(0).toUpperCase() }}</span>
              </span>
              <span class="tk-msg-body">
                <span class="tk-msg-meta">
                  <b>{{ c.user || '-' }}</b>
                  <small>{{ c.date }}</small>
                </span>
                <span class="tk-msg-text">{{ c.text }}</span>
              </span>
            </div>
          </div>
        </div>
      </template>
    </template>
  </modal-2>
</template>

<script type="text/javascript">
  export default {
    props: {
      refDocno: String,
    },
    data() {
      return {
        ui: window.ui,
        xt: $xt,
        auth,
        loading: false,
        docno: '',
        ticket: null,
        comments: [],
      }
    },
    methods: {
      async openModal() {
        this.docno = this.refDocno || ''
        this.ticket = null
        this.comments = []
        if ($xt.isEmpty(this.docno)) return
        this.loading = true
        this.$refs.ticket_modal.setSize('modal-lg')
        this.$refs.ticket_modal.openModal()
        await this.loadTicket()
      },
      closeModal() {
        this.$refs.ticket_modal.closeModal()
      },
      async loadTicket() {
        this.loading = true
        try {
          if ($xt.strStartWith(this.docno, 'PC')) {
            await this.loadPreCase()
            await this.loadPreCaseComments()
          }
          else {
            // OARQ = ใบร้องขอจาก LINE OA / Customer Portal
            // (mg_csr_line_req + mg_csr_line_member, comment จาก mg_csr_req_comment)
            // ดึงมาพร้อมกันในครั้งเดียว จึงไม่ต้องรอ job_no
            await this.loadLineRequest()
          }
        } catch (ex) {
          $msg.alert('System Error', ex, 'danger')
        } finally {
          this.loading = false
        }
      },
      async loadPreCase() {
        let x = await this.findClosedPreCase()
        // เคสที่ยังไม่ถูกปิด (ใบแจ้งงานยังเป็น draft) จะไม่อยู่ใน Read_Complete จึงหาจาก Readlist ต่อ
        if (!x) x = await this.findOpenPreCase()
        if (!x) return
        this.ticket = {
          subject: x.subject,
          doc_date: this.formatDate(x.adddate),
          description: x.desc_remark,
          website_url: x.website_url,
          map_url: '',
          map_gps: '',
          map_desc: '',
          rows: [
            [this.ui.csm_v2_document_no || 'เลขที่เอกสาร', x.docno, 'fa-hashtag', 'navy'],
            [this.ui.erp_customer || 'ลูกค้า', x.cus_name, 'fa-building', 'violet'],
            [this.ui.csm_home_req_by || 'ผู้แจ้ง', x.adduser_name || x.adduser, 'fa-user', 'amber'],
            [this.ui.erp_received_by || 'ผู้รับเรื่อง', x.accept_user_name || x.accept_user, 'fa-user-check', 'teal'],
            ['Job No.', x.job_no, 'fa-clipboard-check', 'green'],
          ],
        }
      },
      async loadLineRequest() {
        let act = `CSM/Data/CSM_Line_Read?reqno=${encodeURIComponent(this.docno)}&baseUrl=${window.dataServer}`
        let rsp = await $xt.getServer(act)
        if (!rsp.success) throw rsp.error
        let x = (rsp.data || {}).data_rows
        if (!x) return
        this.setRequestComments((rsp.data || {}).commentData || [])
        this.ticket = {
          subject: x.subject,
          doc_date: this.formatDate(x.add_dt),
          description: x.description,
          website_url: '',
          map_url: x.map_url,
          map_gps: x.map_gps,
          map_desc: x.map_desc,
          rows: [
            [this.ui.csm_trn2_req_no || 'เลขที่ใบร้องขอ', x.reqno, 'fa-hashtag', 'navy'],
            [this.ui.erp_customer || 'ลูกค้า', x.customer_name, 'fa-building', 'violet'],
            [this.ui.erp_project_name || 'ชื่อโครงการ', x.pre_des, 'fa-folder-open', 'indigo'],
            [this.ui.erp_contact_name || 'ผู้ติดต่อ', x.contract, 'fa-user', 'amber'],
            [this.ui.erp_telephone || 'โทรศัพท์', x.contract_tel, 'fa-phone', 'cyan'],
            // ผู้ใช้ที่ยื่นคำร้องจาก mg_csr_line_member (ตาม userid ของใบร้องขอ)
            [this.ui.csm_v2_member || 'ผู้ใช้งาน', this.memberLabel(x), 'fa-id-badge', 'teal'],
            [this.ui.csm_v2_email || 'อีเมล', x.member_mail, 'fa-envelope', 'rose'],
            [this.ui.csm_trn_field_service_type || 'ประเภทบริการ', x.item_name, 'fa-tags', 'violet'],
            ['Job No.', x.job_no, 'fa-clipboard-check', 'green'],
            [this.ui.erp_remark || 'หมายเหตุ', x.note, 'fa-sticky-note', 'amber'],
            [this.ui.csm_trn_req_reject_reason || 'เหตุผลที่ปฏิเสธ', x.reject_remark, 'fa-ban', 'red'],
          ],
        }
      },
      memberLabel(x) {
        // เบอร์โทรมีช่องของตัวเองอยู่แล้ว จึงคืนแค่ชื่อ ให้ตัวตัดค่าซ้ำจับได้เมื่อชื่อตรงกับผู้ติดต่อ
        return x.member_name || x.userid || ''
      },
      norm(v) {
        return (v == null ? '' : String(v)).replace(/\s+/g, ' ').trim()
      },
      async findClosedPreCase() {
        let act = `CSM/Data/CSM_PreCase_Read_Complete?skip=0&take=1&search_field=docno&search_text=${encodeURIComponent(this.docno)}`
        let rsp = await $xt.getServer(act)
        if (!rsp.success) throw rsp.error
        return ((rsp.data || {}).data_complete || [])[0]
      },
      async findOpenPreCase() {
        let act = `CSM/Data/CSM_PreCase_Readlist?all=Y&all2=Y&it=N`
        let rsp = await $xt.getServer(act)
        if (!rsp.success) throw rsp.error
        let d = rsp.data || {}
        let all = [].concat(d.waitingDev || [], d.waitingIt || [], d.inProgress || [], d.pendingReview || [], d.reject || [])
        return $linq(all).where(w => w.docno == this.docno).firstOrDefault()
      },
      async loadPreCaseComments() {
        let act = `CSM/Data/CSM_ReadComment_PreCase?docno=${encodeURIComponent(this.docno)}`
        let rsp = await $xt.getServer(act)
        if (!rsp.success) return
        let rows = (rsp.data || {}).commentData || []
        this.comments = $linq(rows).orderBy(x => x.itemno).toArray().map(x => {
          // description ถูกเก็บเป็น JSON { text, files } แต่ของเก่าบางรายการยังเป็น string เปล่า
          let d = x.description || {}
          let isText = typeof d === 'string'
          return {
            user: x.add_user,
            date: this.formatDate(x.add_dt),
            text: isText ? d : (d.text || ''),
            img: x.imgPath || x.img,
            is_me: x.add_user == this.auth.userid,
          }
        })
      },
      setRequestComments(rows) {
        this.comments = $linq(rows).orderBy(x => x.itemno).toArray().map(x => ({
          user: x.req_name,
          date: x.date_c,
          text: x.detail_c,
          img: '',
          is_me: x.req_empno == this.auth.empno,
        }))
      },
      showPicture(x) {
        return window.dataServer + 'Api/File/DownLoad?id=' + x
      },
      // สีของ avatar เลือกจากชื่อผู้พูด คนเดิมจะได้สีเดิมทุกครั้งที่เปิดดู
      avatarTone(user) {
        const tones = ['navy', 'violet', 'teal', 'amber', 'rose', 'cyan']
        let s = String(user || '')
        let sum = 0
        for (let i = 0; i < s.length; i++) sum += s.charCodeAt(i)
        return tones[sum % tones.length]
      },
      formatDate(d) {
        if ($xt.isEmpty(d)) return ''
        let m = moment(d, ['DD/MM/YYYY HH:mm:ss', moment.ISO_8601])
        return m.isValid() ? m.format('DD/MM/YYYY HH:mm') : ''
      },
    },
    computed: {
      fields() {
        if (!this.ticket) return []
        // ข้อมูลจริงมักซ้ำกันเอง (note = description, member_name = contract) จึงตัดค่าที่ซ้ำออก
        // เพื่อไม่ให้ตารางมีช่องที่อ่านแล้วได้ข้อความเดิม
        let seen = [this.norm(this.ticket.description)]
        let out = []
        this.ticket.rows.forEach(r => {
          if ($xt.isEmpty(r[1])) return
          let key = this.norm(r[1])
          if (seen.includes(key)) return
          seen.push(key)
          out.push({ label: r[0], value: r[1], icon: r[2] || 'fa-circle', tone: r[3] || 'navy' })
        })
        return out
      },
    },
  }
</script>

<style scoped>
  /* ─── โทนสีกลาง : ทุกบล็อก/ทุกช่องหยิบสีจากชุดนี้ผ่าน .tone-* ───
     ตั้งเป็นตัวแปรเพื่อให้เปลี่ยนสีทีเดียวได้ทั้งไฟล์ และยังคุมให้อยู่ใน
     ตระกูลเดียวกับธีมกรมท่าเดิม (#24365e) ไม่หลุดไปเป็นสีสดจนขัดหน้าอื่น */
  .tk-loading,
  .tk-head,
  .tk-grid,
  .tk-block {
    --c-navy: #2b4a8b;
    --c-indigo: #4c5fd7;
    --c-violet: #8b5cf6;
    --c-teal: #0d9488;
    --c-green: #16a34a;
    --c-amber: #d97706;
    --c-rose: #e11d67;
    --c-cyan: #0891b2;
    --c-red: #dc2626;
  }

  .tk-loading {
    padding: 28px;
    text-align: center;
    color: #64748b;
    font-size: 13px;
  }
  .tk-loading i {
    color: var(--c-navy);
    margin-right: 6px;
  }

  /* ─── หัวเรื่องบน title bar ─── */
  .tk-title {
    display: flex;
    align-items: center;
    gap: 9px;
    margin: 0;
    font-size: 15px;
    font-weight: 600;
  }
  .tk-title-ic {
    width: 26px;
    height: 26px;
    border-radius: 7px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.18);
    border: 1px solid rgba(255, 255, 255, 0.28);
    font-size: 12px;
    flex-shrink: 0;
  }
  /* เลขเอกสารเป็นชิปโมโนสเปซ อ่าน/จำง่ายกว่าตัวหนังสือปกติ */
  .tk-docno {
    padding: 3px 11px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.16);
    border: 1px solid rgba(255, 255, 255, 0.3);
    font-family: "Consolas", "Cascadia Mono", monospace;
    font-size: 13px;
    letter-spacing: 0.5px;
  }

  /* ─── หัวเรื่องของ ticket + วันที่ ─── */
  .tk-head {
    position: relative;
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 14px;
    padding: 12px 16px;
    margin-bottom: 16px;
    border-radius: 10px;
    background: linear-gradient(135deg, #eef2fb 0%, #f6f4fe 100%);
    border: 1px solid #dfe6f5;
    overflow: hidden;
  }
  /* แถบสีซ้ายมือ ทำให้หัวเรื่องเด่นโดยไม่ต้องถมสีทั้งกล่อง */
  .tk-head::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
    background: linear-gradient(180deg, var(--c-navy), var(--c-violet));
  }
  .tk-subject {
    font-size: 15px;
    font-weight: 700;
    color: #16233d;
    line-height: 1.45;
  }
  .tk-date {
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 3px 10px;
    border-radius: 999px;
    background: #fff;
    border: 1px solid #dfe6f5;
    font-size: 11.5px;
    font-weight: 600;
    color: #5b6b86;
    white-space: nowrap;
  }
  .tk-date i {
    font-size: 10px;
    color: var(--c-navy);
  }

  /* ─── ตารางข้อมูล : การ์ดละช่อง มีไอคอนสีนำ ─── */
  .tk-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(235px, 1fr));
    gap: 10px;
  }
  .tk-item {
    --tone: var(--c-navy);
    position: relative;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 9px 12px 9px 13px;
    border: 1px solid #e5eaf3;
    border-radius: 10px;
    background: #fff;
    transition: border-color .15s, box-shadow .15s, transform .15s;
  }
  .tk-item::before {
    content: "";
    position: absolute;
    left: 0;
    top: 8px;
    bottom: 8px;
    width: 3px;
    border-radius: 0 3px 3px 0;
    background: var(--tone);
    opacity: .85;
  }
  .tk-item:hover {
    border-color: var(--tone);
    box-shadow: 0 3px 12px rgba(22, 35, 61, .09);
    transform: translateY(-1px);
  }
  .tk-item-ic {
    flex: 0 0 auto;
    width: 30px;
    height: 30px;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: var(--tone);
    /* พื้นไอคอนใช้สีเดียวกับ tone แต่จางลง ได้ความกลมกลืนโดยไม่ต้องกำหนดสีพื้นแยก */
    background: color-mix(in srgb, var(--tone) 12%, #fff);
  }
  .tk-item-body {
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 1px;
  }
  .tk-label {
    font-size: 10.5px;
    font-weight: 700;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: #94a3b8;
  }
  .tk-value {
    font-size: 13px;
    font-weight: 600;
    color: #16233d;
    word-break: break-word;
  }

  /* เฉดของแต่ละช่อง */
  .tk-item.tone-navy   { --tone: var(--c-navy); }
  .tk-item.tone-indigo { --tone: var(--c-indigo); }
  .tk-item.tone-violet { --tone: var(--c-violet); }
  .tk-item.tone-teal   { --tone: var(--c-teal); }
  .tk-item.tone-green  { --tone: var(--c-green); }
  .tk-item.tone-amber  { --tone: var(--c-amber); }
  .tk-item.tone-rose   { --tone: var(--c-rose); }
  .tk-item.tone-cyan   { --tone: var(--c-cyan); }
  .tk-item.tone-red    { --tone: var(--c-red); }

  /* fallback ให้เบราว์เซอร์ที่ยังไม่รู้จัก color-mix (Chrome < 111) */
  @supports not (background: color-mix(in srgb, red 10%, white)) {
    .tk-item-ic { background: #eef2f9; }
    .tk-head-ic { background: #eef2f9; }
  }

  /* ─── บล็อกเนื้อหา (รายละเอียด / URL / สถานที่ / คอมเมนต์) ─── */
  .tk-block {
    --tone: var(--c-navy);
    margin-top: 18px;
  }
  .tk-block.tone-indigo { --tone: var(--c-indigo); }
  .tk-block.tone-cyan   { --tone: var(--c-cyan); }
  .tk-block.tone-rose   { --tone: var(--c-rose); }
  .tk-block.tone-teal   { --tone: var(--c-teal); }

  .tk-block-head {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
    font-size: 12.5px;
    font-weight: 700;
    color: #33425c;
  }
  .tk-head-ic {
    width: 24px;
    height: 24px;
    border-radius: 7px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    color: #fff;
    background: var(--tone);
    flex-shrink: 0;
  }
  .tk-count {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 20px;
    padding: 0 7px;
    height: 19px;
    border-radius: 999px;
    background: color-mix(in srgb, var(--tone) 14%, #fff);
    color: var(--tone);
    border: 1px solid color-mix(in srgb, var(--tone) 30%, #fff);
    font-size: 11px;
    font-weight: 700;
  }
  @supports not (background: color-mix(in srgb, red 10%, white)) {
    .tk-count { background: #eef2f9; color: #33425c; border-color: #dfe6f5; }
  }

  .tk-desc {
    position: relative;
    white-space: pre-wrap;
    font-size: 13px;
    line-height: 1.65;
    color: #26364f;
    background: #fbfcfe;
    border: 1px solid #e5eaf3;
    border-left: 3px solid var(--tone);
    border-radius: 4px 10px 10px 4px;
    padding: 11px 14px;
    max-height: 220px;
    overflow-y: auto;
  }
  .tk-url {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 7px 13px;
    border-radius: 999px;
    background: #fbfcfe;
    border: 1px solid #dfe6f5;
    font-size: 12.5px;
    font-weight: 600;
    color: var(--tone);
    text-decoration: none;
    word-break: break-all;
  }
  .tk-url:hover {
    background: var(--tone);
    border-color: var(--tone);
    color: #fff;
    text-decoration: none;
  }

  /* ─── การตอบกลับ (comment thread) ─── */
  .tk-chat {
    display: flex;
    flex-direction: column;
    gap: 11px;
    max-height: 290px;
    overflow-y: auto;
    padding: 13px 14px;
    background: linear-gradient(180deg, #fbfcfe 0%, #f5f7fc 100%);
    border: 1px solid #e5eaf3;
    border-radius: 10px;
  }
  .tk-msg {
    display: flex;
    align-items: flex-start;
    gap: 9px;
  }
  /* ข้อความของตัวเองสลับไปอยู่ขวา รูปแบบเดียวกับหน้า Dashboard Case */
  .tk-msg.is-me {
    flex-direction: row-reverse;
  }
  .tk-msg-avatar {
    flex: 0 0 auto;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 700;
    color: #fff;
    background: var(--c-navy);
    box-shadow: 0 2px 6px rgba(22, 35, 61, .18);
  }
  .tk-msg-avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  /* สีสุ่มคงที่ต่อผู้พูด คำนวณจากชื่อใน avatarTone() */
  .tk-msg-avatar.av-navy   { background: linear-gradient(135deg, #2b4a8b, #3b60ab); }
  .tk-msg-avatar.av-violet { background: linear-gradient(135deg, #7c4bf0, #9b6cf8); }
  .tk-msg-avatar.av-teal   { background: linear-gradient(135deg, #0d9488, #14b8a6); }
  .tk-msg-avatar.av-amber  { background: linear-gradient(135deg, #d97706, #f59e0b); }
  .tk-msg-avatar.av-rose   { background: linear-gradient(135deg, #e11d67, #f43f7f); }
  .tk-msg-avatar.av-cyan   { background: linear-gradient(135deg, #0891b2, #06b6d4); }

  .tk-msg-body {
    display: flex;
    flex-direction: column;
    gap: 3px;
    max-width: 78%;
    padding: 9px 13px;
    border: 1px solid #e5eaf3;
    border-radius: 12px 12px 12px 3px;
    background: #fff;
    box-shadow: 0 1px 3px rgba(22, 35, 61, .05);
  }
  .tk-msg.is-me .tk-msg-body {
    border-radius: 12px 12px 3px 12px;
    background: linear-gradient(135deg, #eaf0fd 0%, #f1eefe 100%);
    border-color: #d7e0f6;
  }
  .tk-msg-meta {
    display: flex;
    align-items: baseline;
    gap: 9px;
    font-size: 11px;
    color: #94a3b8;
  }
  .tk-msg-meta b {
    font-size: 12px;
    color: #2b4a8b;
  }
  .tk-msg.is-me .tk-msg-meta b {
    color: #6d3fd4;
  }
  .tk-msg-text {
    white-space: pre-wrap;
    font-size: 13px;
    line-height: 1.6;
    color: #26364f;
    word-break: break-word;
  }

  /* แถบเลื่อนให้เข้ากับโทน ไม่ใช้สีเทาเริ่มต้นของเบราว์เซอร์ */
  .tk-desc::-webkit-scrollbar,
  .tk-chat::-webkit-scrollbar {
    width: 7px;
  }
  .tk-desc::-webkit-scrollbar-thumb,
  .tk-chat::-webkit-scrollbar-thumb {
    background: #c6d2e8;
    border-radius: 4px;
  }
  .tk-desc::-webkit-scrollbar-thumb:hover,
  .tk-chat::-webkit-scrollbar-thumb:hover {
    background: #a9bada;
  }
</style>
